import { useSelector } from 'react-redux';
import CardCategory from './CardCategory';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ROUTER from '../../../routers/Routers';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SectionCategory = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { products } = useSelector(state => state.product);

  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <section className="flex lg:px-[80px] lg:py-[40px] py-[32px] px-[16px] flex-col items-start gap-[24px] self-stretch bg-white">
      <span className="text-headline-small">{t('Products')}</span>
      <div className="lg:grid lg:grid-cols-4 xl:grid-cols-5 flex justify-start overflow-x-auto lg:overflow-visible items-center content-center gap-x-[4px] gap-y-[4px] self-stretch [&::-webkit-scrollbar]:hidden">
        {products.data?.map(item => {
          return (
            <CardCategory
              key={item.id}
              actived={item.id === id}
              label={getValueFromString(item.name)}
              description={`${item.total_products ?? 0} ${t('Products')}`}
              icon={<img src={item.row_image_url} alt={item.name} />}
              onClick={() => {
                navigate(ROUTER.CATEGORY + '/' + item.id);
                const params = Object.fromEntries(searchParams);
                delete params['offset']; // Reset offset về 0 khi có thay đổi
                setSearchParams(params);
              }}
            />
          );
        })}
      </div>
    </section>
  );
};

export default SectionCategory;
